import * as actionTypes from './actionTypes'

export const setAboutRef = (ref) => {
    return {
        type: actionTypes.SET_ABOUT_REF,
        payload: {
            aboutRef: ref
        }
    }
}

export const setAchievementsRef = (ref) => {
    return {
        type: actionTypes.SET_ACHIEVEMENTS_REF,
        payload: {
            achievementsRef: ref
        }
    }
}

export const setBlogsRef = (ref) => {
    return {
        type: actionTypes.SET_BLOGS_REF,
        payload: {
            blogsRef: ref
        }
    }
}

export const setContactRef = (ref) => {
    return {
        type: actionTypes.SET_CONATCT_REF,
        payload: {
            contactRef: ref
        }
    }
}

export const setExperiencesRef = (ref) => {
    return {
        type: actionTypes.SET_EXPERIENCES_REF,
        payload: {
            experiencesRef: ref
        }
    }
}

export const setHomeRef = (ref) => {
    return {
        type: actionTypes.SET_HOME_REF,
        payload: {
            homeRef: ref
        }
    }
}

export const setStrengthsRef = (ref) => {
    return {
        type: actionTypes.SET_STRENGTHS_REF,
        payload: {
            strengthsRef: ref
        }
    }
}